import React from 'react';
import { I18n } from 'react-redux-i18n';

import CardHeader from 'components/CardHeader';
import ExportButton from 'components/Export';
import Select from 'components/Select';
import { getMarketOptions } from 'modules/Prices/helpers';

import { components } from 'apiTyped/types';
import { MarketOption } from 'interface';

const PriceNetworkHeader = ({
  data,
  market,
  exportName,
  setMarket
}: {
  data: components['schemas']['DataDetail'][];
  market: MarketOption | null;
  exportName: string;
  // eslint-disable-next-line no-unused-vars
  setMarket: (e: MarketOption) => void;
}) => {
  const marketOptions = getMarketOptions(data);

  return (
    <>
      <CardHeader
        title={I18n.t('prices.price.allNetworksTitle')}
        fontSize="20px"
        alignItems="center"
        rightComponents={
          <div className="pbcRightComponents ignored-export">
            <ExportButton
              jpg
              pdf
              name={`${exportName}-I18n.t('prices.price.allNetworksTitle')`}
              targetElement="#prices-prix-moyen-barre"
            />
          </div>
        }
        styles={`.cardHeader{white-space:normal;max-width:50%}`}
      />
      <div className="selectsContainer ignored-export">
        <Select
          value={market}
          label={I18n.t('prices.filters.market')}
          placeholder={I18n.t('placeholderAll')}
          options={marketOptions}
          onChange={setMarket}
          minWidth="170px"
          isClearable={true}
          dropdownProps={{
            styles: market ? `margin-left:0px` : `margin-left:-25px`
          }}
          clearProps={{
            styles: `margin-left:-50px`
          }}
        />
      </div>
    </>
  );
};

export default PriceNetworkHeader;
